export class STAT {
    Type: string = "STAT";
    SerialNumber: string;
    Name: string;
    Active: boolean;
    Latitude : number;
    Longitude :number;
    StatusPiece : number;
}